import { createFileRoute, Outlet } from '@tanstack/react-router';
import { WizardShell } from '@/domains/sales/wizard/components/WizardShell';

// Layout de una sesión de venta: monta el shell (stepper + guardar-y-salir) y renderiza el paso.
export const Route = createFileRoute('/wizard/s/$sessionId')({
    component: WizardSessionLayout,
});

function WizardSessionLayout() {
    const { sessionId } = Route.useParams();
    return (
        <WizardShell sessionId={sessionId}>
            <Outlet />
        </WizardShell>
    );
}
